(function () {
  'use strict';
  angular.module('vcfinance.bmfexport')
    .component('bmfexport', {
      restrict: 'E',
      templateUrl: 'vcfinance/bmfexport/bmfexport-component.tpl.html',
      controllerAs: 'vm',
      controller: ['Config', '$log', '$http',
        function (Config, $log, $http) {
          let vm = this;
          vm.name = 'bmfexport';
          vm.rangequery = rangequery;
          vm.conf = Config.$find('configuration');
          // vm.startdate = moment(moment().year() + '-01-01', 'YYYY-MM-DD').toDate();
          vm.startdate = new Date(moment().year(), 0, 1).toISOString();
          $log.debug('Startdate: ', vm.startdate);
          vm.enddate = new Date().toISOString();
          vm.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 1
          };

          vm.altInputFormats = ['yyyy-MM-dd', 'dd.MM.yyyy'];


          let thisyear = {
            $gte: moment().startOf('year').toISOString(),
            $lt: moment().endOf('year').toISOString()
          };

          vm.thisyearquery = '/routes/bmfexport' + '?created=' + encodeURIComponent(JSON.stringify(thisyear));


          function rangequery(start, end) {
            let qq = {
              $gte: start,
              $lt: end
            };
            let tmp = '/routes/bmfexport' + '?created=' + encodeURIComponent(JSON.stringify(qq));
            $log.debug('tmp: ', tmp);
            $http.get(tmp, {})
              .then(function (data, status, headers, config) {
                let anchor = angular.element('<a/>');
                anchor.attr({
                  href: 'data:application/octet-stream;base64,' + encodeURI(data),
                  target: '_blank',
                  download: 'bmfexport.zip'
                })[0].click();
              }, function (err) {
                $log.error('bmfexport filegeneration and export failed: ', err);
              });

          }

        }] // controller
    }); // component

// klammerfriedhof
}());
